import { OrgManagePage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 机构管理（平台侧跨租户，门禁 sys:org:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端开启租户维度（「所属租户」列 + 新建选租户）。
 */
export default function OrgManage() {
  return <OrgManagePage platform hq={hq} />;
}
